import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="font-heading text-4xl font-bold text-foreground-950 mb-4">分类不存在</h1>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap">
              <i className="ri-arrow-left-line"></i> 返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const heroImages: Record<string, string> = {
    'mingxing-tafang': 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20stage%20with%20warm%20golden%20spotlight%20beams%2C%20elegant%20red%20velvet%20curtain%2C%20mysterious%20theater%20atmosphere%2C%20rich%20crimson%20and%20amber%20tones%2C%20artistic%20composition%2C%20no%20people%2C%20cinematic%20wide%20shot%2C%20luxurious%20texture%2C%20subtle%20smoke%20effect&width=1920&height=700&seq=gossip-cat-star&orientation=landscape',
    'wanghong-fanche': 'https://readdy.ai/api/search-image?query=Dark%20empty%20streaming%20studio%20with%20ring%20lights%20turned%20off%2C%20cold%20blue%20ambient%20glow%2C%20abandoned%20modern%20setup%2C%20scattered%20equipment%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20no%20people%2C%20moody%20editorial%20photography%2C%20wide%20composition&width=1920&height=700&seq=gossip-cat-influencer&orientation=landscape',
    'zongyi-neimu': 'https://readdy.ai/api/search-image?query=Empty%20TV%20studio%20stage%20with%20colorful%20spotlights%2C%20judges%20desk%20in%20shadow%2C%20dramatic%20theater%20lighting%2C%20dark%20surroundings%2C%20warm%20red%20and%20amber%20beams%2C%20mysterious%20atmosphere%2C%20no%20people%2C%20cinematic%20wide%20shot%2C%20professional%20broadcast%20setting&width=1920&height=700&seq=gossip-cat-variety&orientation=landscape',
  };

  return (
    <>
      <Navbar />

      <main>
        <section className="relative w-full h-[400px] md:h-[480px] flex items-end overflow-hidden">
          <img
            src={heroImages[slug] || heroImages['mingxing-tafang']}
            alt={category.name}
            title={`${category.name} - 吃瓜爆料`}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

          <div className="relative z-10 w-full pb-14 md:pb-16 px-4 md:px-6">
            <div className="max-w-4xl mx-auto text-center">
              <p className="text-accent-400 text-sm font-medium tracking-widest mb-3 uppercase">
                {category.count} 篇爆料
              </p>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-3">
                {category.name}
              </h1>
              <p className="text-white/70 text-base max-w-xl mx-auto">
                {category.description}
              </p>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {category.name} · 全部爆料
              </h2>
              <Link
                to="/"
                className="text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                <i className="ri-arrow-left-line"></i> 返回首页
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>

            {categoryArticles.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无爆料</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}